<template>
  <v-card>
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card-title class="title  pa-0"> {{ $t('documents.history.title') }} </v-card-title>

          <table class="table">
            <thead>
              <tr>
                <th class="text-left date-width">{{ $t('documents.history.table_header_date') }}</th>
                <th colspan="2" class="text-left status-width">{{ $t('documents.history.table_header_status') }}</th>
                <th class="text-left comment-width">{{ $t('documents.history.table_header_comment') }}</th>
                <th class="text-left">{{ $t('documents.history.table_header_mentor') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in statusi" :key="item.SeminarskiRad_ID">
                <td>{{ item.DatumPromjeneStatusa | moment('DD.MM.YYYY.') }}</td>
                <td class="max">
                  <v-icon :class="getStatusClass(item.Status)"> {{ getStatusIcon(item.Status) }}</v-icon>
                </td>
                <td>
                  {{ getStatusName(item.Status) }}
                </td>
                <td>{{ item.Komentar }}</td>
                <td>{{ item.Mentor }}</td>
              </tr>
            </tbody>
          </table>

        </v-flex>
        <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center" >


        </v-flex>
        <v-flex xs12 md4 class="text-xs-center text-sm-center text-md-center text-lg-center">


        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>


<script>

  export default {
    name: 'SeminarHistoryStatus',

    props: {
      upisPoId: -1,
      //setLoading: { type: Function },
      statusi: { type: Array }
    },

    data() {
      return {
        
      }

    },

    mounted() {
      
    },

    methods: {
      getStatusName(status) {
        switch (status) {
          case 1: return this.$t('documents.history.status_name_1');
          case 2: return this.$t('documents.history.status_name_2');
          case 3: return this.$t('documents.history.status_name_3');
          case 4: return this.$t('documents.history.status_name_4');
          default: return '';
        }
      },

      getStatusClass(status) {
        switch (status) {
          case 1: return 'grey--text'; //Preuzet
          case 2: return 'orange--text'; //Zaprimljen
          case 3: return 'red--text';
          case 4: return 'light-green--text lighten-2';
          default: return '';
        }
      },

      getStatusIcon(status) {
        switch (status) {
          case 1: return 'information'; //Preuzet
          case 2: return 'information'; //Zaprimljen
          case 3: return 'mdi-alert-box';
          case 4: return 'check';
          default: return '';
        }
      },


      
    }
  }
</script>

<style scoped>
  .max {
    max-width:30px;
    
  }

  .date-width {
    width: 15%;
  }

  .status-width {
    /*width: 30%;*/
  }

  .comment-width {
    width: 50%;
  }

  tr td {
    font-weight: 300 !important;
    font-size: 0.9em;
    color: #818080;
  }
</style>



// WEBPACK FOOTER //
// VueSrc/SeminarTask/components/SeminarHistoryStatus.vue